import querystring from "querystring";
export const appendQuery = (url, _params, removeParams) => {
  const arr = url.split("?");
  let query = {};
  let path = url;
  if (arr.length === 1) {
    query = _params;
  } else {
    path = arr[0];
    query = Object.assign(querystring.parse(arr[1]), _params);
  }
  if (removeParams) {
    removeParams.forEach(p => {
      if (query.hasOwnProperty(p)) {
        delete query[p];
      }
    });
  }
  return `${path}?${querystring.stringify(query)}`;
};
export const getPageName = href => {
  const temp = href
    .split("?")[0]
    .split("#")[0]
    .split("/");
  return temp[temp.length - 1];
};
